import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserView, MobileView } from "react-device-detect";
import RoutesMobile from "./components/Routes/RoutesMobile";
import Routes from "./components/Routes";
import { activewellboresActions } from "./redux/reducers/activewellboresReducer";
import { portalsActions } from "./redux/reducers/portalsReducer";
import { usersActions } from "./redux/reducers/usersReducer";
import { compsActions } from "./redux/reducers/compsReducer";
import { incidentsActions } from "./redux/reducers/incidentsReducer";
import { statuswellboresActions } from "./redux/reducers/statuswellboresReducer";
import { generalsActions } from "./redux/reducers/generalsReducer";
import { portalusersActions } from "./redux/reducers/portalusersReducer";
import { useSocketRegistration } from "./hooks/useSocketRegistration";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./common/themeMui";
import { agentsActions } from "./redux/reducers/agentsReducer";

function AppEscort() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  useSocketRegistration(user);

  React.useEffect(() => {
    if (!user) {
      dispatch(activewellboresActions.onClearStore());
      dispatch(portalsActions.onClearStore());
      dispatch(usersActions.onClearStore());
      dispatch(compsActions.onClearStore());
      dispatch(incidentsActions.onClearStore());
      dispatch(statuswellboresActions.onClearStore());
      dispatch(generalsActions.onClearStore());
      dispatch(portalusersActions.onClearStore());
      dispatch(agentsActions.onClearStore());
    }
  }, [user]);

  return (
    <ThemeProvider theme={theme}>
      <BrowserView>
        <Routes currentUser={user} />
      </BrowserView>
      <MobileView>
        <RoutesMobile currentUser={user} />
      </MobileView>
    </ThemeProvider>
  );
}

export default AppEscort;
